import createQueryStore from './createQueryStore';

const store = createQueryStore('subscriptionRestrictions', {
  initialState: {
    // Groups the customer may not subscribe to, as evaluated by the server.
    // Empty means unrestricted, which is also the fail-open default.
    data: { blockedGroups: [], reason: null }
  }
});

export default store.reducer;
export const actions = store.actions;
export const useSubscriptionRestrictionsStore = store.useStore;
